import Reflux from 'reflux';
import { Map, OrderedMap } from 'immutable';
import BaseMixin from 'flux/stores/BaseMixin';
import WordExportFormActions from 'flux/actions/WordExportFormActions';
import EventChangeListenerMixin from 'flux/stores/EventChangeListenerMixin';
import EventViewStore from 'flux/stores/EventViewStore';
import CuesheetStore from 'flux/stores/cuesheet/CuesheetStore';
import DownloadHelper from 'shared/lib/downloadHelper';
import _ from 'underscore';
import { fontSizes } from 'shared/constants/WordExportConstants.js';
import TimeUtil from 'time';
import moment from 'moment';

const defaultFieldVals = {
  displayItemTitles: true,
  displayItemDescriptions: true,
  displayItemNumbers: true,
  displayDuration: true,
  displayPresetDuration: true,
  displayStartTime: true,
  skipEmptyHeroFields: false,
};
/**
 * ExportFormStore
 */
export default Reflux.createStore({
  listenables: [WordExportFormActions],

  mixins: [BaseMixin, EventChangeListenerMixin],

  init() {
    this.listenTo(EventViewStore, 'onEventChange');
    this.listenTo(CuesheetStore, 'onCuesheetChange');

    this._initForm();
  },

  _initForm() {
    this.setState(Map(defaultFieldVals).set('heroFontSize', 'Medium'));
  },

  onUpdateField(field, val) {
    const nextState = this.getState().set(field, val);
    this.setStateAndTrigger(nextState);
  },

  onUpdateColumn(colId, val) {
    this.setInStateAndTrigger(['columns', colId], val);
  },

  onCuesheetChange(state) {
    if (state.has('show')) {
      this._showId = state.getIn(['show', '_id']);
      this._durationDisplayType = state.getIn(['show', 'durationDisplayType']);
      this._presetDurationDisplayType = state.getIn([
        'show',
        'presetDurationDisplayType',
      ]);
    }

    const fullColumns = state.get('fullColumns');
    const columnOrder = state.get('columnOrder');

    if (!fullColumns) return;

    const twentyFourHour = state.getIn(['event', 'twentyFourHourClock']);
    const timeZone = state.getIn(['event', 'timeZone']);

    const next = this.getState().asMutable();
    next.set('fullColumns', fullColumns);

    let columns = OrderedMap();

    let hasHeroField = false;

    fullColumns.forEach((col) => {
      const colId = col.get('_id');
      const isVisible = columnOrder.find((val) => val === colId) ? true : false;
      columns = columns.set(colId, isVisible);
      if (!hasHeroField && isVisible) {
        next.set('heroField', colId);
        hasHeroField = true;
      }
    });

    next.set('columns', columns);

    _.each(defaultFieldVals, (val, key) => {
      if (state.hasIn(['show', key])) {
        next.set(key, state.getIn(['show', key]));
      }
    });

    next.set('twentyFourHour', twentyFourHour);
    next.set('timeZone', timeZone);

    this.setStateAndTrigger(next.asImmutable());
  },

  onClear() {
    this._initForm();
  },

  onSubmit() {
    const fields = [
      'displayItemTitles',
      'durationDisplayType',
      'presetDurationDisplayType',
      'displayItemDescriptions',
      'displayItemNumbers',
      'displayDuration',
      'displayPresetDuration',
      'displayStartTime',
      'heroField',
      'skipEmptyHeroFields',
    ];

    const columns = this.getInState('columns');
    const queryArgs = {};

    fields.forEach((f) => {
      queryArgs[f] = this.getInState(f);
    });

    const heroFontSize = this.getInState('heroFontSize');
    if (heroFontSize && heroFontSize !== 'Default') {
      queryArgs.heroFontSize = fontSizes.get(heroFontSize);
    }

    const timeZone = this.getInState('timeZone');
    const twentyFourHour = this.getInState('twentyFourHour');

    const timeStamp =
      moment.tz(timeZone).format('MM/DD/YY') +
      ' ' +
      TimeUtil.getFormattedTimeWithSeconds(moment(), twentyFourHour, timeZone);

    queryArgs.timeStamp = timeStamp;

    let columnIdQuery = '';

    columns.forEach((val, colId) => {
      if (val) columnIdQuery = columnIdQuery.concat(colId, ',');
    });

    queryArgs.columnIds = columnIdQuery;

    if (this._presetDurationDisplayType) {
      queryArgs.presetDurationDisplayType = this._presetDurationDisplayType;
    }

    if (this._durationDisplayType) {
      queryArgs.durationDisplayType = this._durationDisplayType;
    }

    DownloadHelper.downloadWord(
      {
        teamId: this._teamId,
        eventId: this._eventId,
        showId: this._showId,
      },
      queryArgs,
    );
  },
});
